import LogoImage from './Logo.png'
import styles from './Logo.module.css';
import { useNavigate } from 'react-router-dom';
import { clearMessages } from '../../redux/message/actions.js';
import { useDispatch } from 'react-redux';

function Logo() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleMoveHome = () => {
        dispatch(clearMessages());
        navigate('/');
    }

    return (
        <button className={styles.layout} onClick={handleMoveHome}>
            <img 
                className={styles.logo}
                src={LogoImage}
                alt="Logo" 
            />
        </button>
    );
}

export default Logo;